import {Component, HostListener, OnInit} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import Constants from "../../shared/constants";
import {SharedService} from "../../services/shared/shared.service";
import {IdService} from "../../services/id/id.service";

@Component({
    selector: 'xlog-header',
    templateUrl: './header.component.pug',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
    language = 'AU';
    loaded = false;
    isDropdownVisible = false;
    selectedLocale = '';
    localeLabel = '';

    protected readonly Constants = Constants;

    constructor(
        private http: HttpClient,
        private sharedService: SharedService,
        private id: IdService) {
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
        const dropdownButton = document.querySelector('.dropdown-btn');
        const dropdownMenu = document.querySelector('.dropdown-menu');

        // Close dropdown if the click is outside the button and menu
        if (dropdownButton && dropdownMenu) {
            if (!dropdownButton.contains(event.target as Node) && !dropdownMenu.contains(event.target as Node)) {
                this.isDropdownVisible = false;
            }
        }
    }

    ngOnInit() {
        this.selectedLocale = this.id.getToken(Constants.LOCALE_TOKEN) || 'en-au';
        this.localeLabel = Constants.SUPPORTED_LOCALES.find(locale => locale.key === this.selectedLocale).label;
        this.loadLocaleData(this.selectedLocale);
    }

    toggleDropdown() {
        this.isDropdownVisible = !this.isDropdownVisible;
    }


    selectLocale(locale) {
        if (!locale.disabled && locale.key !== this.selectedLocale) {
            this.selectedLocale = locale.key;
            this.localeLabel = locale.label;
            this.loadLocaleData(locale.key);
            this.isDropdownVisible = false;
            this.sharedService.setLanguageData(true);
            window.location.reload();
        }
    }

    loadLocaleData(locale: string) {
        this.id.setToken(Constants.LOCALE_TOKEN, locale.toLowerCase());
        const url = `${environment.i18nBaseUrl}/${locale.toLowerCase()}.json`;
        this.http.get(url).subscribe(() => {
            this.loaded = true;
        });
    }
}
